const loggedIn = state => {
    return !!state.currentUser;
};

const admin = state => {
    return state.currentUser && state.currentUser.app_metadata.roles.some(role => role === 'ylläpito')
}

const adminLoggedIn = state => {
    return loggedIn(state) && admin(state)
};

const userRoles = state => {
    return loggedIn(state) ? state.currentUser.app_metadata.roles : [M]
};

const rankList = state => {
    return {
        'omistaja': ['omistaja', 'admin', 'operaattori', 'rakentaja', 'moderaattori'],
        'admin': ['admin', 'operaattori', 'rakentaja', 'moderaattori'],
        'operaattori': ['operaattori', 'rakentaja', 'moderaattori'],
        'rakentaja': ['rakentaja', 'moderaattori'],
        'moderaattori': ['moderaattori']
    }
}

const ranks = state => {
    if (!adminLoggedIn(state)) return [];
    let roles = userRoles(state)
    let found = Object.keys(rankList()).find(rank => roles.find(role => role === rank))
    return rankList()[found] || [];
}

export default {
    loggedIn,
    admin,
    adminLoggedIn,
    ranks,
    rankList,
    userRoles,
};